export const AUTH_TOKEN_KEY = 'ccBearerToken'

// Older builds also persisted the whole login payload, JWT included, under this key.
const LEGACY_TOKEN_COPY_KEY = 'meInfo'

function isUsableToken(value: string | null | undefined): value is string {
  return typeof value === 'string' && value.length > 0 && value !== 'undefined' && value !== 'null'
}

export function getAuthToken(): string | null {
  const token = localStorage.getItem(AUTH_TOKEN_KEY)
  return isUsableToken(token) ? token : null
}

export function setAuthToken(token: string | null | undefined): void {
  if (!isUsableToken(token)) return
  localStorage.setItem(AUTH_TOKEN_KEY, token)
  localStorage.removeItem(LEGACY_TOKEN_COPY_KEY)
}

export function clearSession(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY)
  localStorage.removeItem(LEGACY_TOKEN_COPY_KEY)
}

export function isAuthenticated(): boolean {
  return getAuthToken() !== null
}

export function getAuthHeader(): { Authorization: string } | Record<string, never> {
  const token = getAuthToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}
